import { render, staticRenderFns } from "./PlanItem.vue?vue&type=template&id=a750f950&scoped=true"
import script from "./PlanItem.vue?vue&type=script&lang=js"
export * from "./PlanItem.vue?vue&type=script&lang=js"
import style0 from "./PlanItem.vue?vue&type=style&index=0&id=a750f950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a750f950",
  null
  
)

export default component.exports